"use client";

import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { useResource } from "@/lib/use-resource";
import { Busy } from "@/components/ui";

type PublicStatus = {
  name: string;
  state: "online" | "offline" | "unavailable";
  message?: string;
  players?: number;
  address?: string;
};

const labels = { online: "Online", offline: "Offline", unavailable: "Unavailable" } as const;

export function PublicStatusPage({ slug }: { slug: string }) {
  const resource = useResource<PublicStatus>(`/status/${encodeURIComponent(slug)}`, 15000);
  const [copied, setCopied] = useState(false);
  const status = resource.data;
  return (
    <main className="public-status">
      {!status && resource.loading && <Busy />}
      {!status && !resource.loading && (
        <div className="public-status-card">
          <h1>Status page not found</h1>
          <p className="muted">This link is disabled or no longer valid.</p>
        </div>
      )}
      {status && (
        <div className="public-status-card">
          <h1>{status.name}</h1>
          <div className={`public-status-state public-status-${status.state}`} role="status">
            <i />
            {labels[status.state]}
          </div>
          {status.message && <p className="public-status-notice">{status.message}</p>}
          <dl className="public-status-facts">
            {status.players !== undefined && (
              <div>
                <dt>Players online</dt>
                <dd>{status.players}</dd>
              </div>
            )}
            {status.address && (
              <div>
                <dt>Connect</dt>
                <dd className="mono">
                  {status.address}{" "}
                  <button
                    className="icon-button"
                    type="button"
                    aria-label="Copy address"
                    onClick={() => {
                      void navigator.clipboard.writeText(status.address!);
                      setCopied(true);
                      setTimeout(() => setCopied(false), 1500);
                    }}
                  >
                    {copied ? <Check size={14} /> : <Copy size={14} />}
                  </button>
                </dd>
              </div>
            )}
          </dl>
          <small className="muted">Updates every 15 seconds · Powered by Velnqo</small>
        </div>
      )}
    </main>
  );
}
